// extracted by mini-css-extract-plugin
export default {"simpleTimeSlotListContainer":"SimpleTimeSlotList-module__simpleTimeSlotListContainer___1L-ur","durationText":"SimpleTimeSlotList-module__durationText___1Jb1e"};